// Generated by CoffeeScript 1.6.3
(function() {
  rjm.model.CategorySet = Backbone.RelationalModel.extend({
    initialize: function(options) {
      if (!options.hasOwnProperty("categorySelectors")) {
        throw "InvalidConstructorArgs - Category Set";
      }
      return _.bindAll(this, "addCategory", "getCategoryBySid", "removeCategoryBySid", "removeCategoryByIndex", "removeAllCategories", "hasSelectors", "categorySelectorChanged");
    },
    addCategory: function(category) {
      this.get("categorySelectors").add(category);
      return category.bind("change", this.categorySelectorChanged);
    },
    getCategoryBySid: function(sid) {
      return this.get("categorySelectors").find(function(selector) {
        return selector.get("column").get("sid") === +sid || selector.get("column").get("sid") === sid;
      });
    },
    removeCategoryBySid: function(sid) {
      var modelsToBeRemoved,
        _this = this;
      modelsToBeRemoved = this.get("categorySelectors").filter(function(cat) {
        return cat.get("column").get("sid") === +sid || cat.get("column").get("sid") === sid;
      });
      _(modelsToBeRemoved).each(function(categorySelector) {
        return categorySelector.unbind("change", _this.categorySelectorChanged);
      });
      return this.get("categorySelectors").remove(modelsToBeRemoved);
    },
    removeCategoryByIndex: function(index) {
      var categoryToBeRemoved;
      categoryToBeRemoved = this.get("categorySelectors").at(index);
      categoryToBeRemoved.unbind("change", this.categorySelectorChanged);
      return this.get("categorySelectors").remove(categoryToBeRemoved);
    },
    removeAllCategories: function(options) {
      var _this = this;
      this.get("categorySelectors").each(function(categorySelector) {
        return categorySelector.unbind("change", _this.categorySelectorChanged);
      });
      this.get("categorySelectors").reset([], options);
      return this.trigger("remove:categorySelectors");
    },
    hasSelectors: function() {
      if (this.get("categorySelectors").size() === 0) {
        return false;
      }
      return this.get("categorySelectors").some(function(catSelector) {
        return _(catSelector.get("values")).size() > 0;
      });
    },
    categorySelectorChanged: function(categorySelector) {
      return this.trigger("change:categorySelector", categorySelector);
    },
    relations: [
      {
        type: Backbone.HasMany,
        key: "categorySelectors",
        relatedModel: "rjm.model.CategorySelector"
      }
    ]
  });

}).call(this);
